import * as React from 'react';
import { useUserContext } from '../../../shared/context/user-context';
import { useTelemetryContext } from '../../../telemetry/telemetryContext';
import { getUserInfo } from '../../../telemetry/utils';
import NewsFeed from './NewsFeed';
import { translateNewsFeedLabels } from './newsFeedLabels';
import { useNewsFeedQuery } from './queries/useNewsFeedQuery';
import { useMarkNewsAsReadMutation } from './queries/useMarkNewsAsReadMutation';

export default function NewsFeedDataLayer() {
    const { user } = useUserContext();
    const { logger } = useTelemetryContext();

    function logError(origin: string) {
        return (error: unknown) => {
            if (logger) {
                logger.logException(error, { origin, userInfo: getUserInfo(user) });
            }
        };
    }

    const { data } = useNewsFeedQuery(user.details.id, logError('NewsFeed.fetch_news_feed'));
    const markAsReadMutation = useMarkNewsAsReadMutation(
        user.details.id,
        logError('NewsFeed.mark_news_as_read'),
        !user.details.isImpersonated
    );

    return (
        <NewsFeed
            labels={translateNewsFeedLabels()}
            newsItems={data ? data : []}
            onMarkAsRead={(ids) => markAsReadMutation.mutate(ids)}
        />
    );
}
